import { apiGet } from "@/services/api/client";
import { parseActivityLibrary } from "@/services/parsers/activity-parser";
import { parseScaleLibrary } from "@/services/parsers/scale-parser";
import type { ActivityLibrary } from "@/types/activity";
import type { ScaleLibrary } from "@/types/scale";

export interface CatalogData {
  scaleLibrary: ScaleLibrary;
  activityLibrary: ActivityLibrary;
  loadedAt: string;
  version: number;
}

export async function bootstrapCatalog(): Promise<CatalogData> {
  const response = await apiGet<{
    version: number;
    scales: unknown;
    activities: unknown;
  }>("/catalogs/active");
  const scaleLibrary = parseScaleLibrary(response.scales);
  const activityLibrary = parseActivityLibrary(response.activities, {
    validateAgainst: scaleLibrary.entryIndex
  });
  return {
    scaleLibrary,
    activityLibrary,
    loadedAt: new Date().toISOString(),
    version: response.version
  };
}
